module.exports = __webpack_public_path__ + "assets/img/Ultimate-Ears-Social-Static-Ad-w960.8bb27f2a.webp";